import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  ST_INQUIRIES_PROOF_OF_STUDY_CREATE,
  ST_INQUIRIES_PROOF_OF_STUDY_LIST,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const STUDENT_INQUIRIES = GLOBAL_STATE

export const { reducer: studentInquiriesReducer } = createSlice({
  name: STUDENT_INQUIRIES,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.stInquiriesProofOfStudyList.pending, state => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].loading = true
      })
      .addCase(actionCreators.stInquiriesProofOfStudyList.rejected, (state, action) => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].loading = false
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.stInquiriesProofOfStudyList.fulfilled, (state, action) => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].loading = false
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].error = null
        state[ST_INQUIRIES_PROOF_OF_STUDY_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.stInquiriesProofOfStudyCreate.pending, state => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].loading = true
      })
      .addCase(actionCreators.stInquiriesProofOfStudyCreate.rejected, (state, action) => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].loading = false
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.stInquiriesProofOfStudyCreate.fulfilled, (state, action) => {
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].loading = false
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].error = null
        state[ST_INQUIRIES_PROOF_OF_STUDY_CREATE].data = action.payload
      })

    builder.addCase(actionCreators.stInquiriesProofOfStudyListClear, state => {
      state[ST_INQUIRIES_PROOF_OF_STUDY_LIST] = defaultState()
    })
  },
})
